/* Neubau D · Kopf: Mega-Menü (Desktop) und Ebenen in der Menü-Schublade #kd-menu (Handy). Keine Bewegung.
   Desktop: [data-kh-dd] Knopf mit aria-expanded + aria-controls auf ein Feld [data-kh-mega] im selben Listenpunkt.
   Maus: Zeigen öffnet nach kurzer Pause, Verlassen schließt nach kurzer Pause. Klick/Enter/Leertaste schaltet um,
   Pfeil runter öffnet und springt auf den ersten Link, Escape schließt und gibt den Fokus an den Knopf zurück,
   Klick daneben oder Fokus außerhalb des Punkts schließt.
   Handy: [data-kh-go] öffnet die Ebene aus aria-controls, [data-kh-back] geht eine Ebene zurück (Fokus zurück auf den Knopf).
   Beim Öffnen der Schublade (kd-open aus d-kd.js) steht wieder die erste Ebene. Tab bleibt drin (Leitplanke in d-kd.js).
   Suche: Lupe öffnet das Feld unter der Leiste, Vorschläge über Predictive Search (Abschnitt unten). */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const panel = (btn) => document.getElementById(btn.getAttribute('aria-controls'));
  const isOpen = (btn) => btn.getAttribute('aria-expanded') === 'true';
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 220;

  /* ---------- Desktop ---------- */
  let timer = 0;
  let hoverOpened = null;
  function setOpen(btn, on) {
    const p = panel(btn); if (!p) return;
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    p.hidden = !on;
  }
  function closeAll(except) {
    $$('[data-kh-dd][aria-expanded="true"]').forEach((b) => { if (b !== except) setOpen(b, false); });
  }
  /* Jedes Öffnen löscht einen noch laufenden Maus-Zeitgeber, sonst schließt ein alter Verlassen-Zeitgeber das neue Feld. */
  let closeSearch = () => {};
  function show(btn) { clearTimeout(timer); closeAll(btn); closeSearch(); setOpen(btn, true); }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-kh-dd]');
    if (btn) {
      clearTimeout(timer);
      /* Mit der Maus gerade erst aufgegangen: der Klick bestätigt, statt wieder zu schließen. */
      if (hoverOpened === btn && isOpen(btn)) { hoverOpened = null; return; }
      hoverOpened = null;
      if (isOpen(btn)) setOpen(btn, false); else show(btn);
      return;
    }
    if (!e.target.closest('[data-kh-mega]')) closeAll();
  });

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const item = e.target.closest('.kh-nav__item');
    if (!item || !item.closest('.kh-nav')) return;
    const btn = item.querySelector('[data-kh-dd]');
    clearTimeout(timer);
    if (!btn) { timer = setTimeout(closeAll, CLOSE_DELAY); return; }
    if (isOpen(btn)) return;
    timer = setTimeout(() => { show(btn); hoverOpened = btn; setTimeout(() => { if (hoverOpened === btn) hoverOpened = null; }, 600); },
      $$('[data-kh-dd][aria-expanded="true"]').length ? 0 : OPEN_DELAY);
  });
  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const item = e.target.closest('.kh-nav__item');
    if (!item || !item.closest('.kh-nav')) return;
    if (e.relatedTarget && item.contains(e.relatedTarget)) return;
    const inHead = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.kh-nav');
    clearTimeout(timer);
    /* Zwischen zwei Punkten der Reihe übernimmt pointerover; sonst schließen, falls etwas offen ist. */
    if (!inHead && $$('[data-kh-dd][aria-expanded="true"]').length) timer = setTimeout(() => closeAll(), CLOSE_DELAY);
  });

  document.addEventListener('keydown', (e) => {
    const t = e.target;
    const btn = t.closest && t.closest('[data-kh-dd]');
    const mega = t.closest && t.closest('[data-kh-mega]');
    if (e.key === 'Escape') {
      clearTimeout(timer);
      const open = $$('[data-kh-dd][aria-expanded="true"]')[0];
      if (open) { setOpen(open, false); if (mega || btn) open.focus(); }
      return;
    }
    if (btn && e.key === 'ArrowDown') {
      e.preventDefault(); show(btn);
      panel(btn)?.querySelector('a')?.focus();
    }
  });

  /* Gesamtes Sortiment: [data-kh-tab] links wählt genau ein Feld [data-kh-pane] rechts (aria-expanded). Klick, Enter oder
     Zeigen mit der Maus (kurze Pause, damit der schräge Weg zu den Kacheln nicht umschaltet) wählen; Pfeil hoch/runter wandert. */
  let tabTimer = 0;
  function pick(tab) {
    const box = tab.closest('[data-kh-mega]'); if (!box) return;
    $$('[data-kh-tab]', box).forEach((t) => { const on = t === tab; t.setAttribute('aria-expanded', on ? 'true' : 'false'); const p = panel(t); if (p) p.hidden = !on; });
  }
  document.addEventListener('click', (e) => { const tab = e.target.closest('[data-kh-tab]'); if (tab) { clearTimeout(tabTimer); pick(tab); } });
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    clearTimeout(tabTimer);
    const tab = e.target.closest('[data-kh-tab]');
    if (tab && tab.getAttribute('aria-expanded') !== 'true') tabTimer = setTimeout(() => pick(tab), 90);
  });
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest && e.target.closest('[data-kh-tab]');
    if (!tab || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    const all = $$('[data-kh-tab]', tab.closest('[data-kh-mega]'));
    const next = all[all.indexOf(tab) + (e.key === 'ArrowDown' ? 1 : -1)];
    e.preventDefault();
    if (next) { next.focus(); pick(next); }
  });

  document.addEventListener('focusin', (e) => {
    $$('[data-kh-dd][aria-expanded="true"]').forEach((b) => {
      const item = b.closest('.kh-nav__item');
      if (item && !item.contains(e.target)) setOpen(b, false);
    });
  });

  /* ---------- Handy: Ebenen in der Schublade ---------- */
  const stack = [];
  function levelReset(sheet) {
    stack.length = 0;
    $$('.kh-lvl', sheet).forEach((l) => { l.hidden = l.dataset.khLvl !== 'root'; });
    $$('[data-kh-go]', sheet).forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  document.addEventListener('click', (e) => {
    const go = e.target.closest('[data-kh-go]');
    if (go) {
      const from = go.closest('.kh-lvl'); const to = document.getElementById(go.dataset.khGo);
      if (!from || !to) return;
      stack.push({ from, btn: go });
      go.setAttribute('aria-expanded', 'true');
      from.hidden = true; to.hidden = false;
      const sheet = to.closest('[data-kh-menu]'); if (sheet) sheet.scrollTop = 0;
      to.querySelector('.kh-lvl__title')?.focus({ preventScroll: true });
      return;
    }
    const back = e.target.closest('[data-kh-back]');
    if (back) {
      const cur = back.closest('.kh-lvl'); const last = stack.pop();
      if (!cur) return;
      cur.hidden = true;
      const from = last ? last.from : document.querySelector('[data-kh-menu] [data-kh-lvl="root"]');
      if (from) from.hidden = false;
      if (last) { last.btn.setAttribute('aria-expanded', 'false'); last.btn.focus({ preventScroll: false }); }
    }
  });
  document.addEventListener('kd-open', (e) => { if (e.target.matches && e.target.matches('[data-kh-menu]')) levelReset(e.target); });

  /* Kopf klebt oben (CSS .kh-stick): beim Runterscrollen weg, beim Hochscrollen wieder da, ganz oben normal.
     Offenes Mega-Feld oder Fokus im Kopf halten ihn sichtbar. --kh-offset sagt anderen klebenden Teilen, wie hoch er gerade ist. */
  const bar = document.querySelector('.kh-bar');
  const stick = bar && (bar.closest('.shopify-section') || bar);
  if (stick) {
    stick.classList.add('kh-stick');
    const root = document.documentElement;
    let lastY = window.scrollY; let ticking = false;
    const setAway = (away) => {
      if (away && (stick.contains(document.activeElement) || $$('[data-kh-dd][aria-expanded="true"], [data-kh-find][aria-expanded="true"]').length)) away = false;
      stick.classList.toggle('is-away', away);
      if (away) closeAll();
      root.style.setProperty('--kh-offset', away ? '0px' : stick.offsetHeight + 'px');
    };
    const onScroll = () => {
      ticking = false;
      const y = Math.max(window.scrollY, 0); const dy = y - lastY;
      if (y <= stick.offsetHeight) setAway(false);
      else if (dy > 6) setAway(true);
      else if (dy < -6) setAway(false);
      else return;
      lastY = y;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    stick.addEventListener('focusin', () => setAway(false));
    setAway(false);
  }

  /* ---------- Suche: Lupe [data-kh-find] öffnet [data-kh-search] unter der Leiste ----------
     Tippen holt nach kurzer Pause Vorschläge (Shopify Predictive Search, gezeichnet von sections/d-predictive-search.liquid).
     Enter schickt das Formular an /search. Pfeil runter springt in die Vorschläge, Pfeile wandern, Escape schließt und gibt
     den Fokus an die Lupe zurück. Klick oder Fokus außerhalb schließt. Solange offen, bleibt der klebende Kopf sichtbar. */
  const findBtn = document.querySelector('[data-kh-find]');
  const box = findBtn && panel(findBtn);
  if (findBtn && box) {
    const input = box.querySelector('input[name="q"]');
    const res = box.querySelector('[data-kh-sr-box]');
    const note = box.querySelector('[data-kh-sr-n]');
    const base = box.dataset.url || '/search/suggest';
    const cache = new Map();
    let ctrl = null; let wait = 0; let shown = '';
    const say = (n) => {
      if (!note) return;
      note.textContent = n === 0 ? note.dataset.none : n === 1 ? note.dataset.one : (note.dataset.other || '').replace('%n', n);
    };
    const paint = (q, html) => {
      if (q !== input.value.trim()) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sr = doc.querySelector('[data-kh-sr]');
      res.innerHTML = sr ? sr.innerHTML : '';
      shown = q;
      say(sr ? Number(sr.dataset.count || 0) : 0);
    };
    const clear = () => { clearTimeout(wait); if (ctrl) ctrl.abort(); res.innerHTML = ''; shown = ''; if (note) note.textContent = ''; };
    const suggest = (q) => {
      if (!q) { clear(); return; }
      if (q === shown) return;
      if (cache.has(q)) { paint(q, cache.get(q)); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = base + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6'
        + '&resources[options][unavailable_products]=last&section_id=d-predictive-search';
      fetch(url, { signal: ctrl.signal, credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => { cache.set(q, html); paint(q, html); })
        .catch(() => {});
    };
    const openFind = () => {
      closeAll();
      findBtn.setAttribute('aria-expanded', 'true');
      box.hidden = false;
      input.focus();
      if (input.value.trim()) suggest(input.value.trim());
    };
    const closeFind = (refocus) => {
      if (findBtn.getAttribute('aria-expanded') !== 'true') return;
      findBtn.setAttribute('aria-expanded', 'false');
      box.hidden = true;
      clearTimeout(wait);
      if (refocus) findBtn.focus();
    };
    const inFind = (el) => el && (box.contains(el) || findBtn.contains(el));
    findBtn.addEventListener('click', () => { if (findBtn.getAttribute('aria-expanded') === 'true') closeFind(true); else openFind(); });
    box.querySelector('[data-kh-find-close]')?.addEventListener('click', () => closeFind(true));
    input.addEventListener('input', () => { clearTimeout(wait); const q = input.value.trim(); wait = setTimeout(() => suggest(q), q ? 180 : 0); });
    box.querySelector('form')?.addEventListener('submit', (e) => { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    box.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); closeFind(true); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const links = $$('a[href]', res);
      if (!links.length) return;
      const i = links.indexOf(document.activeElement);
      if (e.target === input && e.key === 'ArrowUp') return;
      e.preventDefault();
      if (i < 0) { if (e.key === 'ArrowDown') links[0].focus(); return; }
      if (e.key === 'ArrowUp' && i === 0) { input.focus(); return; }
      links[Math.max(0, Math.min(links.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
    document.addEventListener('click', (e) => { if (!inFind(e.target)) closeFind(false); });
    document.addEventListener('focusin', (e) => { if (!inFind(e.target)) closeFind(false); });
    /* Ein Mega-Feld geht auf (Klick oder Zeigen): die Suche macht Platz. */
    closeSearch = () => closeFind(false);
  }

  /* Schublade: Fokus-Leitplanke (Tab bleibt drin, Escape, Fokus zurück) liegt gemeinsam für alle Fenster in d-kd.js. */
})();
